import { render, staticRenderFns } from "./panel_photo.vue?vue&type=template&id=1fd14642&scoped=true&"
import script from "./panel_photo.vue?vue&type=script&lang=js&"
export * from "./panel_photo.vue?vue&type=script&lang=js&"
import style0 from "./panel_photo.vue?vue&type=style&index=0&id=1fd14642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd14642",
  null
  
)

export default component.exports